import { Grid } from '@material-ui/core';
import { TextFieldLocal } from '../components';
const renderWord = (title: any, word: any, setWord: any) => {
  return (
    <TextFieldLocal
      name="chequeDate"
      label={title}
      value={word}
      onChange={(e: any) => setWord(title, e.target.value)}
      fullWidth
      mb={0}
    />
  );
};

const WordItem = ({ value, setValue }: any) => {
  if (!value) return <div></div>;

  const setItem = (name: any, v: any) => {
    setValue({ ...value, [name]: v });
  };

  return (
    <Grid item xs>
      {renderWord('main', value.main, setItem)}
      {renderWord('operation', value.operation, setItem)}
      {renderWord('operations', value.operations, setItem)}
      {renderWord('appointment', value.appointment, setItem)}
      {renderWord('appointments', value.appointments, setItem)}
      {renderWord('eventsitems', value.eventsitems, setItem)}
      {renderWord('invoicesitems', value.invoicesitems, setItem)}
      {renderWord('task', value.task, setItem)}
      {renderWord('tasks', value.tasks, setItem)}
      {renderWord('department', value.department, setItem)}
      {renderWord('departments', value.departments, setItem)}
      {renderWord('customer', value.customer, setItem)}
      {renderWord('customers', value.customers, setItem)}
      {renderWord('suppliers', value.suppliers, setItem)}
      {renderWord('employee', value.employee, setItem)}
      {renderWord('employees', value.employees, setItem)}
      {renderWord('employee2', value.employee2, setItem)}
      {renderWord('employees2', value.employees2, setItem)}
      {renderWord('resourse', value.resourse, setItem)}
      {renderWord('resourses', value.resourses, setItem)}
      {renderWord('project', value.project, setItem)}
      {renderWord('projects', value.projects, setItem)}
      {renderWord('service', value.service, setItem)}
      {renderWord('services', value.services, setItem)}
      {renderWord('expenseitems', value.expenseitems, setItem)}
      {renderWord('retype', value.retype, setItem)}
      {renderWord('evretype', value.evretype, setItem)}
      {renderWord('evretype2', value.evretype2, setItem)}
    </Grid>
  );
};

const TemplateOptions = ({ temp, setTemp }) => {
  if (!temp) return <div></div>;
  const { words } = temp;

  const setArwords = (wds: any) => {
    const newar = { ...temp.words.ar, ...wds };
    const newwords = {
      en: words.en,
      ar: newar,
    };
    const newtemp = {
      ...temp,
      words: newwords,
    };
    setTemp(newtemp);
  };
  const setEnwords = (wds: any) => {
    const newen = { ...temp.words.en, ...wds };
    const newwords = {
      ar: words.ar,
      en: newen,
    };
    const newtemp = {
      ...temp,
      words: newwords,
    };
    setTemp(newtemp);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <WordItem value={words.ar} setValue={setArwords}></WordItem>
      </Grid>
      <Grid item xs={6}>
        <WordItem value={words.en} setValue={setEnwords}></WordItem>
      </Grid>
    </Grid>
  );
};

export default TemplateOptions;
